import React from 'react';

// UGC 分享中心公共徽标 (列表页/详情页共用).

// 加工模式 / 工艺类型 / 光源的显示名不在这里维护, 一律从平台字典取 (SSOT, 见 §开发规范 复用优先):
//   加工模式 → utils/mmodeText  useMModeText()      (mm_mode 字典)
//   工艺类型 → utils/dictOptions useProcessTypeText() (dict process_type, 跨框架合并)
//   光源     → utils/dictOptions useDictText('light_source')

// 是否通过 (社区准入审核) 徽标.
export function AuditBadge({ status }: { status: string }) {
    const map: Record<string, { text: string; cls: string }> = {
        approved: { text: '✓ 通过', cls: 'bg-emerald-50 text-emerald-600 border-emerald-200' },
        rejected: { text: '✕ 驳回', cls: 'bg-rose-50 text-rose-600 border-rose-200' },
        pending: { text: '待审核', cls: 'bg-amber-50 text-amber-600 border-amber-200' },
    };
    const v = map[status] || { text: '未入审', cls: 'bg-slate-50 text-slate-400 border-slate-200' };
    return (
        <span className={`inline-block px-2 py-0.5 rounded-full border text-[11px] whitespace-nowrap ${v.cls}`}>
            {v.text}
        </span>
    );
}
